const styles = theme => ({
  grid: {
    position: 'relative',
    width: '100%',
    flexBasis: 'unset',
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
  },
  childGrid: {
    marginBottom: theme.spacing(1.5),
    background: 'url(/assets/dummy-image-background.jpg)',
    height: 200,
    flexBasis: 'unset',
    justifyContent: 'center',
    alignItems: 'center',
  },

  button: {
    borderColor: '#1890FF',
    color: '#1890FF',
    textTransform: 'none',
  },
  linkBox: {
    display: 'flex',
    flexDirection: 'row',
    //justifyContent: 'center',
    alignItems: 'center',
    //margin: '0 auto',
    maxWidth: '90%',
    textAlign: 'center',
  },
  addBox: {
    margin: '0 auto',
    textAlign: 'center',
  },
  leftIcon: {
    marginRight: theme.spacing(1),
  },
  actionButton: {
    marginLeft: theme.spacing(1),
  },
  editIcon: {
    position: 'absolute',
    top: 0,
    right: 0,
    width: '40px',
    height: '40px',
  },
  gridContainer: {
    border: '1px dashed #E0E0E0',
    padding: '4px',
    borderRadius: '8px',
  },
})

export default styles
